import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export type GetOpsGenieScheduleFeatureStateResponse = {
	key: string;
	value: boolean;
};

export const getOpsGenieScheduleFeatureState = (
	projectId: string | number,
	isSimplifiedProject: boolean,
): Promise<GetOpsGenieScheduleFeatureStateResponse> => {
	const opsGenieProperty = isSimplifiedProject
		? 'project-sidebar-simple-on-call-schedule'
		: 'devopsgraph.is-opsgenie-integration-enabled';
	return performGetRequest(`/rest/api/2/project/${projectId}/properties/${opsGenieProperty}`).catch(
		(thrownError) => {
			/** If feature has never been set before 404 is returned. But default state of feature is enabled. */
			if (thrownError.statusCode === 404) {
				return Promise.resolve({
					key: `${opsGenieProperty}`,
					value: true,
				});
			}
			return Promise.reject(thrownError);
		},
	);
};
